// ============================================================================
// COLORS
// ============================================================================

export const PURPLE = '#7C3AED';
export const DPURP = '#2E1065';
export const GOLD = '#FFC53D';
export const LGOLD = '#FFE8A3';
export const DGOLD = '#D9911A';
export const GREEN = '#16A34A';
export const LGREEN = '#DCFCE7';
export const RED = '#DC2626';
export const LRED = '#FEE2E2';
export const GRAY = '#6B7280';
export const LGRAY = '#E5E7EB';
export const BG = '#F6F2FF';
export const WHITE = '#FFFFFF';
